import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import Modal from '../../display/Modal'
import InvisibleButton from '../../display/InvisibleButton'
import CloseIcon from '../../icons/AirbnbClose'
import { HeadingLg } from '../../display/Typography'

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: solid 1px #d3d3d3;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  z-index: 1;
  padding: 16px;
`

const CloseButton = styled(InvisibleButton)`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 14px;
    height: 14px;
    margin: 0;
  }
`

const Content = styled.div`
  padding: 0 16px;
`

type Props = React.ComponentProps<typeof Modal> & {
  title?: React.ReactNode
  narrowOnDesktop?: boolean
}

const TrayModal: React.FC<Props> = ({
  title,
  children,
  isOpen,
  narrowOnDesktop,
  onRequestClose,
}) => {
  const { md: largerThanMd } = useMediaQueryContext()

  const modalClassName = [
    'ReactModal__Content',
    'c-basic-modal__content',
    'white',
    'rounded',
    ...(!largerThanMd
      ? ['bottom-align', 'half-screen-max', 'rounded-top']
      : []),
    ...(largerThanMd && narrowOnDesktop ? ['narrow'] : []),
  ].join(' ')

  const modalOverlayClassName = [
    'ReactModal__Overlay',
    'c-basic-modal__overlay',
  ].join(' ')

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={modalClassName}
      overlayClassName={modalOverlayClassName}
    >
      <Header>
        <HeadingLg style={{ margin: 0 }}>{title}</HeadingLg>
        <CloseButton
          aria-label="Close modal"
          onClick={onRequestClose}
          style={{ paddingRight: 0 }}
        >
          <CloseIcon />
        </CloseButton>
      </Header>

      <Content>{children}</Content>
    </Modal>
  )
}

export default TrayModal
